import Restful from '../utils/restful.js'
const project = 'sci/'

// 账户相关
const apc = new Restful(project, 'apc')
export default apc
